import React from 'react';
import MateriaisPopover from '../../../../detail/components/MateriaisPopover';
import AreaTipoDivergenciaEnum from '../../../AreaTipoDivergenciaEnum';
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from '../../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../../template/UseBuildSubmitHandler';
import {
  transforSelectItemToDivergenciaInfo,
} from '../../../template/utils';
import TipoDivergenciasKey from '../../../TipoDivergenciasKey';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import SubstituicaoMPObservacaoStep, { PayloadMateriaisProblemProps } from './SubstituicaoMPObservacaoStep'
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import LabelValueWithSubtitle from '../../../components/LabelValueWithSubtitle';

const SubstituicaoMPFinalStep: TipoDivergenciaComponent<PayloadMateriaisProblemProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {

  const onBackHandler = () => {
    onBack({
      component: SubstituicaoMPObservacaoStep as TipoDivergenciaComponent,
      payload: {
        materiais: payload.materiais,
      },
    });
  };
  
  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.AJUSTE_MATERIA_PRIMA,
      'Substituição de mp'
    ),
    <MateriaisPopover
      materiais={payload.materiais.map(transforSelectItemToDivergenciaInfo)}
    ></MateriaisPopover>,
    <LabelValueWithSubtitle
      label='Descrição do problema'
      value={`${payload.problemDescription}`}
      subtitle={''}
    />
  ];

  const key = TipoDivergenciasKey.SUBSTITUICAO_DE_MP;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(
          step, [
            ...payload.materiais.map((item) => ({
              tipo: item.tipo,
              value: item.id.toString(),
              material: item.material
            })),
            {
              tipo: TipoDivergenciasInfoKey.AJUSTE_MP,
              value: payload.problemDescription,
            }
          ]
        );
      }}
      progressValue={90}
      stepNumber={'4'}
      infoComponents={infoComponents}
    />
  );
};

export default SubstituicaoMPFinalStep;
